export const GET_AUDITS_USERS = "GET_AUDITS_USERS"
export const GET_AUDITS_USERS_CLONE = "GET_AUDITS_USERS_CLONE"
export const GET_AUDITS_TYPES = "GET_AUDITS_TYPES"
export const GET_AUDITS_TYPES_USERS = "GET_AUDITS_TYPES_USERS"